import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BannerService } from 'src/app/services/banner/banner.service';
export interface BannerItem {
  id: number;
  lang: string;

  title: string;
  url: string;

  target: number | string; // 0/1 ან '_self'/'_blank'

  // optional (შენ გინდა null იყოს)
  src?: string | null;     // DB column: src
  width?: number | null;
  height?: number | null;

  visible?: number;        // 0/1
  sort?: number;
  pos?: number;
  place?: string | null;
}
@Component({
  selector: 'app-banner-modal',
  imports: [CommonModule, FormsModule],
  templateUrl: './banner-modal.component.html',
  styleUrl: './banner-modal.component.css'
})
export class BannerModalComponent {
  @Input() itemId: number | null = null;
  @Input() lang: string = 'geo';

  loading = false;
  saving = false;

  model: Partial<BannerItem> = {
    title: '',
    url: '',
    target: '_self',
    visible: 1,

    // სურათი არ გვინდა:
    src: null,
    width: null,
    height: null,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private bannerService: BannerService
  ) {}

  ngOnInit() {
    if (this.itemId) {
      this.loading = true;
      this.bannerService.show(this.itemId, this.lang).subscribe({
        next: (res) => {
          const data = res?.data;
          this.model = {
            ...data,
            // target normalization UI-ზე
            target: (data as any)?.target == 1 ? '_blank' : '_self',
            // image/src -> null თუ გინდა
            src: (data as any)?.src ?? null,
            width: (data as any)?.width ?? null,
            height: (data as any)?.height ?? null,
          };
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
    }
  }

  save() {
    this.saving = true;

    // normalize payload
    const payload: any = {
      lang: this.lang,
      title: (this.model.title ?? '').trim(),
      url: (this.model.url ?? '').trim(),
      target: this.model.target ?? '_self',
      visible: this.model.visible ?? 1,

      // შენ როგორც გინდა — საერთოდ არ ვაგზავნით ან null:
      image: null,
      width: null,
      height: null,
    };

    const req$ = this.itemId
      ? this.bannerService.update(this.itemId, payload)
      : this.bannerService.create(payload);

    req$.subscribe({
      next: () => {
        this.saving = false;
        this.activeModal.close(true);
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
